import useLocalStorage from "hooks/useLocalStorage"
import { useCallback, useEffect, useRef, useState } from "react"
import NodeEntity from "services/entities/NodeEntity"
import { useEntity } from "hooks/useAxios"

const useComparedNodeStorage = (currentNodeId) => {
  const [nodes, setNodes] = useState([])
  const [storage, setLocalStorage] = useLocalStorage("comparedNodes")
  const nodeEntity = useEntity(NodeEntity)
  const [isInitialised, setIsInitialised] = useState(false)
  const storageRef = useRef(storage)
  const setLocalStorageRef = useRef(setLocalStorage)

  useEffect(() => {
    storageRef.current = storage
    setLocalStorageRef.current = setLocalStorage
  }, [storage, setLocalStorage])

  useEffect(async () => {
    if (storage && currentNodeId) {
      setIsInitialised(false)

      const ids = storage[currentNodeId] || []
      const { data } = await nodeEntity.breadcrumbIndex(ids)
      setNodes(data)

      setIsInitialised(true)
    }
  }, [currentNodeId])

  const setStoredNodes = useCallback(
    (newNodes) => {
      if (!currentNodeId) return
      if (!newNodes || !Array.isArray(newNodes)) return

      const currentStorage = storageRef.current || {}
      setLocalStorageRef.current({
        ...currentStorage,
        [currentNodeId]: newNodes.map((n) => n.id),
      })
    },
    [currentNodeId]
  )

  return {
    nodes,
    setStoredNodes,
    isStoredNodesInitialized: isInitialised,
  }
}

export default useComparedNodeStorage
